<div *ngIf="settings$ | async" [formGroup]="form" class="content">
   <div class="flex flex--justify-between flex--align-center">
      <div class="flex">
         <h3 class="me-3">Settings</h3>
      </div>

      <div>
         <button
            mat-raised-button
            *hasAuthorities="[Authority.ManageCompanies]"
            class="me-3"
            color="primary"
            (click)="updateAllStatistics()"
         >
            Update All Companies Statistics
         </button>

         @if (!environment.production || showHideButtons) {
            <button mat-raised-button class="me-3" color="primary" (click)="resendSaleNotifications()">
               Resend Sale Notifications
            </button>

            <ng-container *hasAuthorities="[Authority.ManagePayoff]">
               <button mat-raised-button class="me-3" color="primary" (click)="recalculatePayoff()">
                  Recalculate Payoff
               </button>

               <button mat-raised-button class="me-3" color="primary" (click)="clearPayoff()">Clear Payoff</button>
            </ng-container>
            <button mat-raised-button class="me-3" color="primary" (click)="clearCashRegister()">
               Clear Cash Register
            </button>
         }

         <button mat-raised-button color="accent" (click)="saveSettings()">Save</button>
      </div>
   </div>

   <mat-card class="mb-4">
      <mat-card-content>
         <p class="mb-4">General settings</p>

         <div class="row">
            <div class="col-6">
               <app-select-file-field
                  formControlName="logoId"
                  label="Logo"
                  [type]="fileType.CompanyLogo"
                  class="col"
               ></app-select-file-field>
            </div>
            <div class="col-6">
               <app-select-file-field
                  formControlName="incognitoLogoId"
                  label="Incognito Logo"
                  [type]="fileType.CompanyIncognitoLogo"
                  class="col"
               ></app-select-file-field>
            </div>
            <div class="col-6">
               <app-select-file-field
                  formControlName="imageId"
                  label="Image (promoter app)"
                  [type]="fileType.CompanyImage"
                  class="col"
               ></app-select-file-field>
            </div>
            <div class="col-6">
               <app-select-file-field
                  formControlName="incognitoImageId"
                  label="Incognito Image (promoter app)"
                  [type]="fileType.CompanyIncognitoImage"
                  class="col"
               ></app-select-file-field>
            </div>
         </div>

         <div class="row mt-3">
            <div class="col-4">
               <app-input-field
                  label="Company name"
                  placeholder="Enter company name"
                  formControlName="companyName"
               ></app-input-field>
            </div>

            <div class="col-4">
               <app-input-field label="Address" placeholder="Enter address" formControlName="address"></app-input-field>
            </div>
            <div class="col-4">
               <app-select-field
                  formControlName="destinationId"
                  label="Destination"
                  [options]="destinationOptions"
               ></app-select-field>
            </div>
         </div>

         <div class="row mt-3">
            <div class="col-4">
               <app-input-field
                  label="Credit card cost (%)"
                  placeholder="Enter ex 1.5"
                  formControlName="creditCardFee"
                  type="number"
               ></app-input-field>
            </div>

            <div class="col-4">
               <app-input-field
                  label="Hours for ticket edit (promoter)"
                  placeholder="Enter ex 1"
                  formControlName="ticketEditHours"
                  type="number"
               ></app-input-field>
            </div>

            <div class="col-4">
               <app-input-field
                  label="Paid full label (Default is Paid Full)"
                  placeholder="Enter label"
                  formControlName="paidFullLabel"
               ></app-input-field>
            </div>

            <div class="col-4">
               <mat-checkbox formControlName="payoffExcludeZeroAmount">Payoff Exclude Zero Amount</mat-checkbox>
            </div>
         </div>

         <div class="flex flex--align-center">
            <p>Online Fees</p>
            <button mat-icon-button color="accent" (click)="addOnlineFee()">
               <mat-icon>add</mat-icon>
            </button>
         </div>

         <ng-container formArrayName="onlineFees">
            @for (field of onlineFees.controls; track i; let i = $index) {
               <div class="row" [formGroupName]="i">
                  <div class="col-2">
                     <app-input-field
                        label="Minimum Price"
                        placeholder="Enter Minimum Price (ex. 0)"
                        formControlName="minPrice"
                        type="number"
                     ></app-input-field>
                  </div>
                  <div class="col-2">
                     <app-input-field
                        label="Maximum Price"
                        placeholder="Enter Maximum Price (ex. 300)"
                        formControlName="maxPrice"
                        type="number"
                     ></app-input-field>
                  </div>
                  <div class="col-2">
                     <app-input-field
                        label="Percentage"
                        placeholder="Enter Percentage (ex. 3)"
                        formControlName="percentage"
                        type="number"
                     ></app-input-field>
                  </div>
                  <div class="col-auto">
                     <button mat-icon-button color="accent" (click)="removeOnlineFee(i)">
                        <mat-icon>remove</mat-icon>
                     </button>
                  </div>
               </div>
            }
         </ng-container>
      </mat-card-content>
   </mat-card>

   <mat-card class="mb-4">
      <mat-card-content>
         <p class="mb-4">Invoice Settings</p>

         <div class="row mb-3">
            <div class="col-12">
               <mat-checkbox formControlName="invoiceEnabled">Send invoice to customer on pickup</mat-checkbox>
            </div>
         </div>

         <div class="row">
            <div class="col-4">
               <app-input-field
                  label="VAT number"
                  placeholder="Enter VAT number"
                  formControlName="vatNumber"
               ></app-input-field>
            </div>

            <div class="col-4">
               <app-input-field
                  label="Invoice number prefix"
                  placeholder="Enter prefix (ex. INV-2026-)"
                  formControlName="invoiceNumberPrefix"
               ></app-input-field>
            </div>
         </div>

         <div class="row mt-3">
            <div class="col-12">
               <app-input-field
                  label="Invoice footer / notes"
                  placeholder="Enter footer notes"
                  formControlName="invoiceFooterNotes"
                  type="textarea"
                  [rows]="3"
                  subscriptSizing="dynamic"
               ></app-input-field>
            </div>
         </div>

         <div class="flex flex--align-center mt-3">
            <p>Packages</p>
            <button mat-icon-button color="accent" (click)="addInvoicePackage()">
               <mat-icon>add</mat-icon>
            </button>
         </div>

         <ng-container formArrayName="invoicePackages">
            @for (field of invoicePackages.controls; track i; let i = $index) {
               <div class="row" [formGroupName]="i">
                  <div class="col-2">
                     <app-input-field
                        label="Minimum Price"
                        placeholder="Enter Minimum Price (ex. 0)"
                        formControlName="minPrice"
                        type="number"
                     ></app-input-field>
                  </div>
                  <div class="col-2">
                     <app-input-field
                        label="Maximum Price"
                        placeholder="Enter Maximum Price (ex. 300)"
                        formControlName="maxPrice"
                        type="number"
                     ></app-input-field>
                  </div>
                  <div class="col-4">
                     <app-input-field
                        label="Package name"
                        placeholder="Enter package name"
                        formControlName="name"
                     ></app-input-field>
                  </div>
                  <div class="col-auto">
                     <button mat-icon-button color="accent" (click)="removeInvoicePackage(i)">
                        <mat-icon>remove</mat-icon>
                     </button>
                  </div>
               </div>
            }
         </ng-container>

         <div class="mt-4">
            <p>Invoice Labels</p>
            <small class="text-muted">Leave empty to use the defaults shown in each field.</small>
         </div>

         <div class="row mt-2" formGroupName="invoiceLabels">
            <div class="col-4">
               <app-input-field label="Title" placeholder="INVOICE" formControlName="title"></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field label="Number" placeholder="No" formControlName="number"></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field label="Date" placeholder="Date" formControlName="date"></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field
                  label="Description"
                  placeholder="Descripción"
                  formControlName="description"
               ></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field label="Amount" placeholder="Amount" formControlName="amount"></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field
                  label="Total Online"
                  placeholder="Total received"
                  formControlName="totalOnline"
               ></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field
                  label="Total Offline (Cash)"
                  placeholder="Total recibido"
                  formControlName="totalOffline"
               ></app-input-field>
            </div>
            <div class="col-4">
               <app-input-field
                  label="Event Organizer"
                  placeholder="Event Organizer"
                  formControlName="eventOrganizer"
               ></app-input-field>
            </div>
         </div>
      </mat-card-content>
   </mat-card>

   <mat-card class="mb-4">
      <mat-card-content>
         <p class="mb-4">Payment Settings</p>

         <div class="row">
            <div class="col">
               <app-select-field
                  formControlName="paymentProvider"
                  label="Select payment provider"
                  [options]="paymentProviderOptions"
               ></app-select-field>
            </div>
         </div>

         @if (paymentProvider === PaymentProvider.SUMUP) {
            <div class="row">
               <div class="col">
                  <app-input-field
                     label="SumUp Client Id"
                     placeholder="Enter Client Id for Sumup"
                     formControlName="sumUpClientId"
                  ></app-input-field>
               </div>

               <div class="col">
                  <app-input-field
                     label="SumUp Client Secret"
                     placeholder="Enter Client Secret for Sumup"
                     formControlName="sumUpClientSecret"
                  ></app-input-field>
               </div>

               <div class="col">
                  <app-input-field
                     label="Merchant Code"
                     placeholder="Enter Mrchant Code from Sumup"
                     formControlName="merchantCode"
                  ></app-input-field>
               </div>

               <div class="col">
                  <app-input-field
                     label="Api Key"
                     placeholder="Enter Api Key from Sumup"
                     formControlName="sumUpApiKey"
                  ></app-input-field>
               </div>
            </div>
         } @else if (paymentProvider === PaymentProvider.MOLLIE) {
            <div class="row">
               <div class="col">
                  <app-input-field
                     label="Mollie API key"
                     placeholder="Enter mollie api key"
                     formControlName="mollieApiKey"
                  ></app-input-field>
               </div>
            </div>
         }

         <div class="row">
            <div class="col">
               <app-input-field
                  label="Payment expire time"
                  placeholder="Enter expiration time in minutes (e.g., 60)"
                  formControlName="paymentExpireAfter"
                  type="number"
               ></app-input-field>
            </div>

            <div class="col">
               <app-input-field
                  label="Deposit payment expire time"
                  placeholder="Enter expiration time in minutes (e.g., 60)"
                  formControlName="paymentDepositExpireAfter"
                  type="number"
               ></app-input-field>
            </div>

            <div class="col">
               <app-input-field
                  label="Automatically ghost expired tickets after X minutes"
                  placeholder="Enter duration in minutes"
                  formControlName="ghostExpiredTicketsAfterMinutes"
                  type="number"
               ></app-input-field>
            </div>
         </div>

         <div class="row">
            <div class="col-12">
               <mat-checkbox formControlName="allowDepositPOS">Allow Deposit POS</mat-checkbox>
               <mat-checkbox formControlName="webTicketsApproval">
                  Manually approve tickets that are fully paid via WEB.
               </mat-checkbox>
            </div>
         </div>
      </mat-card-content>
   </mat-card>

   <mat-card>
      <mat-card-content>
         <ng-container formGroupName="ticketSettings">
            <p class="mb-4">Ticket Form</p>
            <div class="row">
               <div class="col-3 mb-3" formGroupName="lastName">
                  <span class="ms-2">Last Name</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="phone">
                  <span class="ms-2">Phone</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="email">
                  <span class="ms-2">Email</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="alternativePhone">
                  <span class="ms-2">Alternative Phone</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="customerNationalityId">
                  <span class="ms-2">Guest Nationality</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="residenceId">
                  <span class="ms-2">Residence</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="hotelId">
                  <span class="ms-2">Hotel</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="tourOperatorId">
                  <span class="ms-2">Tour Operator</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="pickupLocationId">
                  <span class="ms-2">Pickup Location</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="saleLocationId">
                  <span class="ms-2">Sale Location</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="message">
                  <span class="ms-2">Message</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="plannedPickupDate">
                  <span class="ms-2">Planned Pickup Date</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="arrivalDate">
                  <span class="ms-2">Arrival Date</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="departureDate">
                  <span class="ms-2">Departure Date</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="bottle">
                  <span class="ms-2">Bottle</span>
                  <div>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="preferredPaymentLink">
                  <span class="ms-2">Payment link type</span>
                  <div>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>

               <div class="col-3 mb-3" formGroupName="membershipEventId">
                  <span class="ms-2">Membership</span>
                  <div>
                     <mat-checkbox formControlName="required">Require</mat-checkbox>
                     <mat-checkbox formControlName="hidden">Hidden</mat-checkbox>
                  </div>
               </div>
            </div>
         </ng-container>

         <mat-checkbox formControlName="splitPromoters">Allow splitting the Promoters for Promoters</mat-checkbox>
         <mat-checkbox formControlName="hidePromoterRanking">Hide Promoter Ranking</mat-checkbox>
      </mat-card-content>
   </mat-card>
</div>
